// ViewModalIncludeDescendantsSection.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Components
import Checkbox from 'components/checkbox/Checkbox';

/**
 * ViewModalIncludeDescendantsSection
 *
 * Shows the optional "include descendants" checkbox.
 *
 * @returns {ReactNode} The rendered component.
 */
const ViewModalIncludeDescendantsSection = ({
    isVisible,
    label,
    value,
    onToggle,
}) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    if (!isVisible) return null;
    // ----- RENDER ----- //

    return (
        <div className="view-modal-section">
            <div className="view-modal-section-header">
                <div
                  className="view-modal-section-title"
                  style={{
                    color: theme.foregroundMuted,
                  }}
                >
                    Depth
                </div>
            </div>
            <Checkbox
              label={label}
              value={value}
              size={24}
              onChange={onToggle}
            />
        </div>
    );
};

// Dev Tools
ViewModalIncludeDescendantsSection.displayName = 'ViewModalIncludeDescendantsSection';

export default ViewModalIncludeDescendantsSection;
